import type { LedgerEntry } from '../api/types'
import { formatCredits, timeAgo } from '../utils/format'

const REASONS: Record<LedgerEntry['reason'], string> = {
  allowance: 'Monthly credits',
  purchase: 'Credit pack',
  grant: 'Granted',
  charge: 'Used',
}

/** Credit ledger entries, newest first, with the balance after each. */
export function LedgerTable({ entries }: { entries: LedgerEntry[] }) {
  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            <th>When</th>
            <th>What</th>
            <th className="num">Change</th>
            <th className="num">Balance after</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry.id}>
              <td className="muted" title={new Date(entry.created_at).toLocaleString()}>
                {timeAgo(entry.created_at)}
              </td>
              <td>
                {entry.note ?? REASONS[entry.reason]}
                {entry.written_off > 0 && (
                  <div className="muted small">{formatCredits(entry.written_off, 'up')} more than the balance covered; not billed</div>
                )}
              </td>
              <td className={`num ${entry.delta < 0 ? '' : 'credit-in'}`}>
                {entry.delta > 0 ? '+' : ''}
                {formatCredits(entry.delta, 'exact')}
              </td>
              <td className="num muted">{formatCredits(entry.allowance_after + entry.extra_after, 'exact')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
